<template>
  <div></div>
</template>
<script>
export default {
  data() {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// login.vue?06686ff8